import { POSTS_A } from "./posts-a.js";
import { POSTS_B } from "./posts-b.js";
import { POSTS_C } from "./posts-c.js";
import { POSTS_D } from "./posts-d.js";
import { POSTS_E } from "./posts-e.js";
import { POSTS_F } from "./posts-f.js";

export const BLOG_CATEGORIES = [
  { key: "Poojas & Homas", kn: "ಪೂಜೆ ಮತ್ತು ಹೋಮಗಳು" },
  { key: "Festivals & Muhurta", kn: "ಹಬ್ಬ ಮತ್ತು ಮುಹೂರ್ತ" },
  { key: "Samskaras", kn: "ಸಂಸ್ಕಾರಗಳು" },
  { key: "Vratas", kn: "ವ್ರತಗಳು" },
  { key: "Astrology", kn: "ಜ್ಯೋತಿಷ್ಯ" },
  { key: "Purohith Guide", kn: "ಪುರೋಹಿತ ಮಾರ್ಗದರ್ಶಿ" },
  { key: "Bengaluru Guide", kn: "ಬೆಂಗಳೂರು ಮಾರ್ಗದರ್ಶಿ" },
];

export const BLOG_AUTHOR = "PurohithConnect Editorial";

export const BLOG_POSTS = [...POSTS_A, ...POSTS_B, ...POSTS_C, ...POSTS_D, ...POSTS_E, ...POSTS_F].sort((a, b) => (a.date < b.date ? 1 : -1));

export const getPost = (slug) => BLOG_POSTS.find((p) => p.slug === slug);

export const formatDate = (iso) => new Date(iso + "T00:00:00").toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
